module.exports = __webpack_public_path__ + "img/vegetable-summer-squash-190x100.e91df414.jpg";